import React from "react";
import { useDispatch } from "react-redux";
import { TextField, Grid } from "@material-ui/core";
import { getLocalizedString } from "@icarius-localization/strings";
import ButtonDialogAction from "@icarius-common/buttonDialogAction";
import { createFamilyAsignationAction, modifyFamilyAsignationAction } from "../../actions";
import { openSnackbarAction } from "@icarius-common/snackbar/actions";
import useHandleForm from "./useHandleForm";
import CustomNumberFormat from '@icarius-common/dynamicInputs/customNumberFormat';

const gridStyle = { height: 75, padding: "0px 10px" };

const Form = (props) => {

  const { data, handleClose } = props;
  const dispatch = useDispatch();

  const create = (dataToSend) => {
    dispatch(createFamilyAsignationAction(dataToSend))
    .then((res) => res?.status === 200 && handleClose());
  }

  const modify = (dataToSend) => {
    dispatch(modifyFamilyAsignationAction(dataToSend))
    .then((res) => res?.status === 200 && handleClose());
  }

  const openValidationError = () => {
    dispatch(openSnackbarAction({ msg: getLocalizedString("invalidData"), severity: "error", duration: 10000 }));
  }

  const {
    isCreate,
    formData,
    setFormValue,
    submit
  } = useHandleForm(data, create, modify, openValidationError);

  return (
    <Grid container item xs={12} direction="row" style={{ paddingTop: 10 }}>
      <Grid container item xs={12}>
        <Grid container item alignItems="center" xs={12} md={4} style={gridStyle}> {/* codigo */}
          <TextField
            disabled={!Boolean(isCreate)}
            required
            fullWidth
            margin={"none"}            
            label={getLocalizedString("sectionAlt")}
            onChange={(e) => setFormValue(e.target.value, "code")}
            value={formData.code}
            inputProps={{ maxLength: 3 }}
          />
        </Grid>
        <Grid container item alignItems="center" xs={12} md={4} style={gridStyle}> {/* Hasta */}
          <TextField            
            required
            InputProps={{ inputComponent: CustomNumberFormat }}
            fullWidth
            margin={"none"}            
            label={getLocalizedString("pollTo")}
            value={formData.to}
            onChange={(e) => setFormValue(e.target.value, "to")}
            inputProps={{ min: "0", step: "0.01", decimals: 2 }}
          />
        </Grid>
        <Grid container item alignItems="center" xs={12} md={4} style={gridStyle}> {/* Value */}
          <TextField            
            required
            InputProps={{ inputComponent: CustomNumberFormat }}
            fullWidth
            margin={"none"}            
            label={getLocalizedString("value")}
            value={formData.value}
            onChange={(e) => setFormValue(e.target.value, "value")}
            inputProps={{ min: "0", step: "0.01", decimals: 2 }}
          />
        </Grid>
      </Grid>      
      <Grid container item xs={12} justify={"flex-end"} alignItems="center" style={{ paddingBottom: 20 }}>        
        <ButtonDialogAction isAccept onClick={submit} text={getLocalizedString("save")} />
      </Grid>      
    </Grid>
  );
}

export default Form;
